import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { FC, useMemo } from 'react';

import { useLoc } from '../lib/hooks';


type DateRangePickerProps = RangePickerProps & { futureRange?: boolean };

export const DateRangePicker: FC<DateRangePickerProps> = ({ futureRange, presets: presetsRaw, ...props }) => {
    const loc = useLoc();
    const presets = useMemo<any>(() => {
        if (presetsRaw) return presetsRaw;

        return [
            {
                label: loc.word('DateRange.todayLabel', { default: 'Today' }),
                value: [dayjs().startOf('day'), dayjs().endOf('day')]
            },
            {
                label: loc.word('DateRange.thisWeekLabel', { default: 'This week' }),
                value: [dayjs().startOf('week'), dayjs().endOf('week')]
            },
            {
                label: loc.word('DateRange.lastWeekLabel', { default: 'Last week' }),
                value: [dayjs().add(-1, 'week').startOf('week'), dayjs().add(-1, 'week').endOf('week')]
            },
            {
                label: loc.word('DateRange.thisMonthLabel', { default: 'This month' }),
                value: [dayjs().startOf('month'), dayjs().endOf('month')]
            },
            {
                label: loc.word('DateRange.lastMonthLabel', { default: 'Last month' }),
                value: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')]
            }
        ];
    }, [loc, presetsRaw]);

    return <DatePicker.RangePicker {...props} presets={presets} />;
};
